import { Attachment } from '../../types';
import { callExternalApi } from '../callExternalApi';

export interface FilePublicUrlResponse {
  url: string;
}

export interface AttachmentUploadResponse {
  message: string;
  id: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ProgressHandler = (progressEvent: any) => void;

export const fetchAttachments = async (parentId: string) => {
  return callExternalApi<Attachment[]>({
    url: `api/files?parent_id=${parentId}`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const uploadAttachment = (attachment: Attachment, progressHandler: ProgressHandler, parentId: string) => {
  const formData = new FormData();
  formData.append('file', attachment.file);
  formData.append('parent_id', parentId);

  return callExternalApi<AttachmentUploadResponse>({
    url: 'api/files',
    method: 'post',
    headers: {
      'content-type': 'multipart/form-data'
    },
    cancelToken: attachment.cancelSource.token,
    data: formData,
    onUploadProgress: progressHandler
  });
};

export const deleteAttachment = (attachmentId: string) => {
  return callExternalApi<void>({
    url: `api/files/${attachmentId}`,
    method: 'DELETE',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const downloadAttachment = async (attachmentId: string) => {
  return callExternalApi<Blob>({
    url: `api/files/${attachmentId}/download`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    },
    responseType: 'blob'
  });
};

export const getAttachmentPublicUrl = async (id: string, filename: string) => {
  return await callExternalApi<FilePublicUrlResponse>({
    url: `api/files/${id}/public-link/${filename}`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};
